import React, {Component} from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import '../styles/Footer.less';

export default class Footer extends Component{

    year;

    constructor() {
        super();
        this.year = new Date().getFullYear();
    }

    render() {
        return (
            <footer>
                <Grid>
                    <Row>
                        <Col sm={4} className="text-left">
                            <ul className="list-unstyled">
                                <li>Email: info@fortepiano-unterricht.de</li>
                                <li>Tel.: 0176 / 4852 9775</li>
                                {/* <li>Impressum</li> */}
                            </ul>
                        </Col>
                        <Col sm={4}>
                            &copy; 2010 - {this.year} Kateryna Byelousova
                        </Col>
                        <Col sm={4}>
                            <a href="http://sldk.de" target="_blank"><i className="fp fp-code"/> by sldk</a>
                        </Col>
                    </Row>
                </Grid>
            </footer>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js